import { Directive, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[numberInputHandler]'
})
export class NumberInputHandlerDirective implements OnInit, OnDestroy {

    @Input() numberInputDecimalPlaces: number = 2;
    @Input() numberInputNegativeEnabled: boolean = true;
    stepSize: number = 1;

    constructor(
        private elRef: ElementRef,
        private control: NgControl
    ) { }

    keydownHandler = (e) => {
        if (e.which === 38 || e.which === 40) {
            let value = this.control.value ? +this.control.value.replace(/,/g, '') : 0;
            if (e.which === 38) {
                value += this.stepSize;
            } else {
                value -= this.stepSize;
            }

            if (!this.numberInputNegativeEnabled) {
                value = value < 0 ? 0 : value;
            }

            this.control.control.setValue(value.toFixed(this.numberInputDecimalPlaces));
            this.control.control.markAsDirty();
            e.preventDefault();
        }
    }

    ngOnInit() {
        this.elRef.nativeElement.addEventListener('keydown', this.keydownHandler);

        let index = +this.numberInputDecimalPlaces;
        while (index > 0) {
            this.stepSize = this.stepSize / 10;
            index--;
        }
    }

    ngOnDestroy() {
        this.elRef.nativeElement.removeEventListener('keydown', this.keydownHandler);
    }
}
